var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ban-form',{attrs:{"title":"Bann hinzufügen","ban":_vm.ban},on:{"addban":_vm.addBan}})
}
var staticRenderFns = []

export { render, staticRenderFns }